import { ArrowRight, ChevronLeft } from 'lucide-react';
import { logoUrl as miniLogo, APP_NAME } from '../../../_assets/branding';
import { NavSearchTrigger } from './NavSearchTrigger';
import './NavigationHeader.scss';

export const NavigationHeader = ({
  isSettingsMode,
  handleSettingsBack,
  mini,
  onToggleCollapse,
}) => {
  return (
    <div className="nav-header">
      <div className="nav-header__wrapper">
        {isSettingsMode ? (
          <div className="nav-header__settings-block">
            <div className="nav-header__logo-wrapper">
              <img className="nav-header__logo-img" src={miniLogo} alt="logo" />
              <p className={`nav-header__company-name ${mini ? "nav-header__company-name--hidden" : ""}`}>
                {APP_NAME}
              </p>
            </div>
            <NavSearchTrigger mini={mini} />
            <div
              className={`nav-header__back-wrapper ${mini ? "nav-header__back-wrapper--mini" : ""}`}
              onClick={handleSettingsBack}
              title="Back to dashboard"
              aria-label="Back to dashboard"
            >
              <ArrowRight size={16} />
              {!mini && <p>Back to dashboard</p>}
            </div>
          </div>
        ) : (
          <>
            <div className="nav-header__logo-wrapper">
              <img className="nav-header__logo-img" src={miniLogo} alt="logo" />
              <p className={`nav-header__company-name ${mini ? "nav-header__company-name--hidden" : ""}`}>
                {APP_NAME}
              </p>
            </div>
            {!mini && (
              <button
                type="button"
                className="nav-header__collapse-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  onToggleCollapse();
                }}
                title="Collapse sidebar"
                aria-label="Collapse sidebar"
              >
                <ChevronLeft size={14} />
              </button>
            )}
          </>
        )}
      </div>
      <div className="nav-header__divider"></div>
    </div>
  );
};
